import CryptoJS from "crypto-js";

export default function DecryptToken(Encrypted) {
  const decrypted = CryptoJS.AES.decrypt(
    Encrypted,
    process.env.REACT_APP_SECRET
  );
  const str = decrypted.toString(CryptoJS.enc.Utf8);
  return str;
}
